<template>
  <div>
    <h3 class="font-weight-bold">Emails</h3>

    <table class="table mt-2">
      <tbody v-for="email in emails" v-bind:key="email.id">
        <tr v-if="email.defaultEmail">
          <button-component :nolink="true"
            :value="email.email"
            v-if="email.defaultEmail"
            class="btn btn-outline-primary mb-3"
            v-b-modal.bv-modal-email
            @click.native="setEmail(email.email)">
            <span><i class="fa fa-paper-plane"></i></span>
            <span>Enviar email</span>
            <b-spinner v-if="loading" small class="buttonSpinner">
            </b-spinner>
          </button-component>
        </tr>
        <tr :class="email.defaultEmail ? 'font-weight-bold' : ''">
          <td>{{ email.source + ': ' + email.email }}</td>
          <td>{{ email.confirmed ? 'Confirmado' : '' }}</td>
          <td>{{ email.defaultEmail ? 'Padrão' : '' }}</td>
          <td class="text-right">
            <div class="dropdown">
              <button class="btn btn-bare dropdown-toggle pl-2 pr-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="m-0 fa fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="#" @click="makeDefaultEmail(email.id)">Tornar Padrão</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <form class="form-inline mb-5">
      <div class="form-group mx-sm-3">
        <label for="new-phone" class="sr-only">Novo email</label>
        <b-form-input class="form-control" type="email" placeholder="Novo e-mail" autocomplete="email" v-model="newEmail"></b-form-input>
      </div>
      <b-button variant="primary" @click="addEmail">Adicionar</b-button>
    </form>

    <b-modal id="bv-modal-email" size="lg" @ok="sendEmail">
      <template slot="modal-title">
        <div>
          <b-form-select v-model="selected" :options="options"></b-form-select>
        </div>
      </template>
      <div class="d-block">
        <b-form-group
          id="input-group-1"
          label="Título:"
          label-for="input-1"
          v-if="selected !== null"
        >
        <span v-html="selected.emailTitle"></span>
        </b-form-group>
        <b-form-group
          id="input-group-1"
          label="Texto:"
          label-for="input-1"
          v-if="selected !== null"
        >
        <span v-html="selected.emailContent">
        </span>
        </b-form-group>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Button from '../../button/Button.vue'
import Input from '../../form/Input.vue'

export default {
  components: {
    'button-component': Button,
    'input-component': Input
  },
  data () {
    return {
      emails: null,
      newEmail: null,
      to: '',
      emailUser: '',
      loading: false,
      selected: null,
      options: [
        { value: null, text: 'Selecione uma opção' },
        { value: {
          emailTitle: `Falta pouco para aprovarmos seu Boleto Parcelado BoletoFlex`,
          emailContent: `<head></head><body>Olá <b>${this.extractFirstName(this.user.name)}</b>, tudo bem?<br/><br/><p>Recebemos o seu pedido ${this.reference} realizado na ${this.tx.sellerName}.</p><br/>Por favor entre em contato por  <a href="https://wa.me/5548996683593?text=Novo número para pedido ${this.reference}!" target="_blank"><b>WhatsApp no número 48 99668-3593</b></a> para avaliarmos a sua aprovação.<p></p><p></p><br/>Atte.<p>Atendimento BoletoFlex</p></body>`
        },
        text: 'Entrar em contato por WhatsApp' },
        { value: {
          emailTitle: `Seu pedido na ${this.tx.sellerName} expirou. Refaça sua compra com o Boleto Parcelado!`,
          emailContent: `Olá <b>${this.extractFirstName(this.user.name)}</b>, tudo bem?<br/><br/><p>Seu pedido ${this.reference} <b>expirou</b>, por favor refaça sua compra e pague com o Boleto Parcelado utilizando um número com WhatsApp ativo.</p><br/><p>Lembre-se de sempre utilizar <b>dados de uma única pessoa</b>, principalmente o Facebook/Google, e-mail, telefone com WhatsApp e sua selfie em local bem iluminado.<p></p><p></p><br/>Atte.<p>Atendimento BoletoFlex</p>`
        },
        text: 'Refazer pedido na Loja' }
      ]
    }
  },
  props: ['user', 'tx', 'reference'],
  methods: {
    setEmail (email) {
      this.emailUser = email
    },
    sendEmail () {
      if (this.selected) {
        this.loading = true
        console.log('EMAIL ' + this.emailUser)
        this.$http.post(`api/validations/${this.$route.params.txid}/sendEmail`, {
          from: 'BoletoFlex <ola@boletoflex.com>',
          to: this.emailUser,
          subject: 'Assunto',
          data: {
            titulo: this.selected.emailTitle,
            corpo: this.selected.emailContent
          },
          attachments: null,
          templateId: 'd-e40814abf66c40b5a725c926ab16e2c2'
        })
          .then(function (res) {
            this.loading = false
            console.log(res)
            this.$bvToast.toast(`E-mail enviado com sucesso !`, {
              title: 'E-mail de solicitação de Whatsapp',
              autoHideDelay: 5000,
              variant: 'primary'
            })
          })
          .catch(function (res) {
            this.loading = false
            console.log('Error')
            console.log(res)
            this.$bvToast.toast(`Problema ao enviar email ${res.data}`, {
              title: 'Erro ao enviar',
              autoHideDelay: 10000,
              variant: 'danger'
            })
          })
      }
    },
    loadEmails () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/emails')
        .then(function (res) {
          this.emails = res.data.list
          this.emails = this.emails.sort(function (a, b) {
            return (a.defaultEmail === b.defaultEmail) ? 0 : a.defaultEmail ? -1 : 1
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    addEmail () {
      this.$http.post('api/validations/' + this.$route.params.txid + '/emails', {email: this.newEmail})
        .then(function (res) {
          this.loadEmails()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(`${this.newEmail} ${res.data}`, {
            title: 'Erro ao adicionar',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    makeDefaultEmail (id) {
      this.$http.post('api/validations/' + this.$route.params.txid + '/emails/' + id)
        .then(function (res) {
          this.loadEmails()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(`${res.data}`, {
            title: 'Erro ao marcar como padrão',
            autoHideDelay: 10000,
            variant: 'danger'
          })
        })
    },
    extractFirstName (name) {
      let index = name.trim().indexOf(' ')
      return index > 0 ? name.substring(0, index) : name
    }
  },
  mounted () {
    this.loadEmails()
  },
  watch: {
    '$route.params.txid' () {
      this.loadEmails()
    }
  }
}
</script>
<style lang="scss">
.emailButton {
  width: 100%;
  margin-bottom: 15px;
}

.buttonSpinner {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/cards/contacts/ContactEmailManager.vue